(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
  function rematesObserveProductVideos(root) {
    root.querySelectorAll('.remates-product-video').forEach(function(wrapper) {
      if (wrapper.dataset.videoObserved) return;
      wrapper.dataset.videoObserved = 'true';
      new MutationObserver(function() {
        if (wrapper.classList.contains('hidden')) {
          var video = wrapper.querySelector('video');
          if (video) video.pause();
        }
      }).observe(wrapper, { attributes: true, attributeFilter: ['class'] });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { rematesObserveProductVideos(document); });
  } else {
    rematesObserveProductVideos(document);
  }
  document.addEventListener('shopify:section:load', function(event) { rematesObserveProductVideos(event.target); });

  } catch(e) { console.error(e); }
})();
})();
